import Text404SVG from '@components/RequestProject/Text404SVG';
import Title from '@components/RequestProject/Title';
import ErrorPageLayout from '@components/RequestProject/ErrorPageLayout';
import ErrorMessage from '@components/RequestProject/ErrorMessage';
import Background404Wrapper from '@styles/requestViews/Background404Wrapper';
import ContentWrapper from '@styles/requestViews/ContentWrapper';

const WhiteLabel404Page = () => (
  <ErrorPageLayout>
    <Background404Wrapper>
      <Text404SVG />
    </Background404Wrapper>
    <ContentWrapper>
      <div>
        <Title>We can’t find this page!</Title>
      </div>
      <ErrorMessage>
        Sorry, but it seems this page doesn’t exist anymore...
      </ErrorMessage>
    </ContentWrapper>
  </ErrorPageLayout>
);

export default WhiteLabel404Page;
